import { Product } from '../../types';

export const bulletSeriesProducts: Product[] = [
  {
    id: "bt-bullet-swt007003f",
    name: "Bullet Series Terminal - CB103 Female (SWT007003F)",
    slug: "bullet-terminal-cb103-female-swt007003f",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CB103 female bullet terminal for automotive wiring. High conductivity brass construction.",
    partNumber: "SWT007003F",
    specifications: {
      "Tab Size Ø": "3.80 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "CB103",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007003F.jpg"],
    tags: ["terminal", "bullet", "female", "brass", "cb103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007003m",
    name: "Bullet Series Terminal - CA103 Male (SWT007003M)",
    slug: "bullet-terminal-ca103-male-swt007003m",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CA103 male bullet terminal for automotive wiring. High conductivity brass construction.",
    partNumber: "SWT007003M",
    featured: true,
    specifications: {
      "Tab Size Ø": "3.50 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "CA103",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007003M.jpg"],
    tags: ["terminal", "bullet", "male", "brass", "ca103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007004f",
    name: "Bullet Series Terminal - CB104 Female (SWT007004F)",
    slug: "bullet-terminal-cb104-female-swt007004f",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CB104 female bullet terminal for automotive wiring. High conductivity brass construction.",
    partNumber: "SWT007004F",
    specifications: {
      "Tab Size Ø": "4.10 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "CB104",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007004F.jpg"],
    tags: ["terminal", "bullet", "female", "brass", "cb104"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007004m",
    name: "Bullet Series Terminal - CA104 Male (SWT007004M)",
    slug: "bullet-terminal-ca104-male-swt007004m",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CA104 male bullet terminal for automotive wiring. High conductivity brass construction.",
    partNumber: "SWT007004M",
    specifications: {
      "Tab Size Ø": "4.00 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "CA104",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007004M.jpg"],
    tags: ["terminal", "bullet", "male", "brass", "ca104"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007005f",
    name: "Bullet Series Terminal - CB105 Female (SWT007005F)",
    slug: "bullet-terminal-cb105-female-swt007005f",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CB105 female bullet terminal for automotive wiring. Larger size for higher current applications.",
    partNumber: "SWT007005F",
    specifications: {
      "Tab Size Ø": "5.40 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "CB105",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007005F.jpg"],
    tags: ["terminal", "bullet", "female", "brass", "cb105"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007005m",
    name: "Bullet Series Terminal - CA105 Male (SWT007005M)",
    slug: "bullet-terminal-ca105-male-swt007005m",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "CA105 male bullet terminal for automotive wiring. Larger size for higher current applications.",
    partNumber: "SWT007005M",
    specifications: {
      "Tab Size Ø": "4.40 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "CA105",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007005M.jpg"],
    tags: ["terminal", "bullet", "male", "brass", "ca105"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-bullet-swt007006",
    name: "Bullet Series Terminal - 2 Way 104 (SWT007006)",
    slug: "bullet-terminal-2-way-104-swt007006",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "2 Way 104 bullet terminal connector. Multi-way connector for branching connections.",
    partNumber: "SWT007006",
    specifications: {
      "Tab Size Ø": "3.96 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "2 Way 104",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2500 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007006.jpg"],
    tags: ["terminal", "bullet", "2-way", "brass", "multi-way"],
    applications: ["Automotive", "Electrical Connections", "Branching"],
  },
  {
    id: "bt-bullet-swt007007",
    name: "Bullet Series Terminal - 3 Way Terminal (SWT007007)",
    slug: "bullet-terminal-3-way-swt007007",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "3 Way Terminal bullet connector. Multi-way connector for branching three connections.",
    partNumber: "SWT007007",
    specifications: {
      "Tab Size Ø": "3.50 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "3 Way Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2500 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007007.jpg"],
    tags: ["terminal", "bullet", "3-way", "brass", "multi-way"],
    applications: ["Automotive", "Electrical Connections", "Branching"],
  },
  {
    id: "bt-bullet-swt007008",
    name: "Bullet Series Terminal - 4 Way Terminal (SWT007008)",
    slug: "bullet-terminal-4-way-swt007008",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "4 Way Terminal bullet connector. Multi-way connector for branching four connections.",
    partNumber: "SWT007008",
    specifications: {
      "Tab Size Ø": "4.50 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "4 Way Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007008.jpg"],
    tags: ["terminal", "bullet", "4-way", "brass", "multi-way"],
    applications: ["Automotive", "Electrical Connections", "Branching"],
  },
  {
    id: "bt-bullet-swt007009",
    name: "Bullet Series Terminal - 4 Way Terminal (SWT007009)",
    slug: "bullet-terminal-4-way-swt007009",
    category: "Brass Terminal",
    subcategory: "Bullet Series",
    description: "4 Way Terminal bullet connector. Multi-way connector with robust design for branching four connections.",
    partNumber: "SWT007009",
    specifications: {
      "Tab Size Ø": "4.50 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "4 Way Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/bullet-series/SWT007009.jpg"],
    tags: ["terminal", "bullet", "4-way", "brass", "multi-way"],
    applications: ["Automotive", "Electrical Connections", "Branching"],
  },
];
